'use strict';

export const selectAccordionElements = () => ({
    questions: document.querySelectorAll('.question'),
    answer: question => {
        return question.querySelector('.answer');
    },
    content: question => {
        return question.querySelector('.answer .content');
    }
});
